import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {ITableColumn} from '../../table-column';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class TableComponent<ITableDataItem extends {id: number}> {

    @Input({required:true}) columns: ITableColumn[];
    @Input({required:true}) data: ITableDataItem[];
    @Input({required: true}) emptyDataTemplate:TemplateRef<unknown>;
    @Input() selectable: boolean = false;
    @Input() selection:ITableDataItem[] = [];
    @Input() class: string = '';
    @Input() isLegalHubPlaybooksList: boolean = false;
    @Input() rowDetailsTemplate: TemplateRef<unknown>;

    @Output() rowClicked  = new EventEmitter<ITableDataItem>();
    @Output() selectionChanged = new EventEmitter<ITableDataItem[]>();


    get isAllSelected(){
        if (this.selection && this.selectable && this.data?.length > 0) {
            return  this.selection?.length === this.data?.length;
        }
        return false;
    }

    onRowClick(dataItem: ITableDataItem) {
        this.rowClicked.next(dataItem);
    }

    onSelectAllChange() {
        if(this.isAllSelected){
            this.selectionChanged.next([]);
        }else{
            this.selectionChanged.next(this.data || []);
        }
    }

    isSelected(dataItem: ITableDataItem) {
         return this.selection?.some(x=>x.id === dataItem.id);
    }

    onSelectionChange(item: ITableDataItem) {
        const newSelection = [...this.selection || []];
        const index = newSelection?.findIndex(x=>x.id === item.id);

        if ( index > -1) {
            newSelection.splice(index,1);
        }else{
            newSelection.push(item);
        }

        this.selectionChanged.next(newSelection);
    }
}
